module.exports = __webpack_public_path__ + "media/images/icon-persona-bf06696de38870aded278d165d34ae6a.svg";